import React from 'react'
import { UserLoan } from '@matech/thebigpos-sdk'
import { useIntl } from 'react-intl'
import { ModalAddCoBorrower } from './modals/ModalAddCoBorrower'
import { useLoanContext } from '../contexts/LoanContext'
import { useSiteConfig } from '../hooks'
import useUser from '../hooks/useUser'
import {
	LanguageContext,
	LanguageContextProps,
} from '../contexts/LanguageContext'
import { Button } from './Button'

const AddCoBorrowerButton = () => {
	const { loanData, loan } = useLoanContext()
	const { siteConfig } = useSiteConfig()
	const { user } = useUser()
	const { formatMessage } = useIntl()

	const [isAddCoBorrowerModalVisible, setIsAddCoBorrowerModalVisble] =
		React.useState(false)
	const { locale } =
		React.useContext<LanguageContextProps>(LanguageContext)

	const handleOpenAddCoBorrowerModal = () => {
		setIsAddCoBorrowerModalVisble(true)
	}

	const handleCloseAddCoBorrowerModal = () => {
		setIsAddCoBorrowerModalVisble(false)
	}

	if (!siteConfig?.enabledServices?.addCoBorrower) {
		return null
	}
	return (
		<div>
			<Button
				variant="contained"
				text={formatMessage({
					id: 'add_coborrower_form.add_a_coborrower',
				})}
				onClick={handleOpenAddCoBorrowerModal}
				disabled={loan?.isLocked}
			/>
			<ModalAddCoBorrower
				blacklist={loanData?.userLoans?.map(
					(borrower: UserLoan) => borrower?.user?.email
				)}
				role={user?.role}
				visible={isAddCoBorrowerModalVisible}
				onClose={handleCloseAddCoBorrowerModal}
				setVisible={undefined}
				siteConfig={siteConfig}
				locale={locale}
			/>
		</div>
	)
}

export default AddCoBorrowerButton
